module.exports = __webpack_public_path__ + "img/Learning.c57c9537.gif";